import {
  Component,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  Input,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { APIService } from '../../../../../api/api.service';
import { NotifierService } from '../../../../../_services/notifier.service';
import { environment } from 'src/environments/environment';
declare let $: any;
declare let flatpickr: any;

import * as moment from 'moment';

@Component({
  selector: 'new-mrr-update',
  templateUrl: './mrr-new.component.html',
  styleUrls: [
    '../../../../../views/cbs/enableri/update/update.enableri.component.css',
  ],
})
export class NewMRRUpdateComponent implements OnInit, OnDestroy {
  selectedServiceNames: any[] = [];
  isAllSelect: boolean = false;
  serviceNamelist: any = [];
  currentMessage: any;
  userId = localStorage.getItem('eId');
  ut = localStorage.getItem('ut');
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  writeAccess: boolean =
    localStorage.getItem('acT') == 'readandwrite' ||
    this.urlPrefix == 'admin' ||
    localStorage.getItem('ut') == 'admin';
  loading = true;
  accountId: any;
  //   date: any;
  @Output() hideModel = new EventEmitter<any>();
  @Input('action') action: any;
  @Input() mrr: any;
  @Input() mrrDatasub: any;
  @Input() unsaved: any;
  @Input() mrrData: any;
  @Input() mid: any;
  @Input() subEc2: any;
  @Input() subRds: any;
  @Input() s3Mrr: any;
  @Input() cfrcMrr: any;
  @Input() s3Keys: any;
  @Input() cfrcKeys: any;
  // In NewMRRUpdateComponent
  @Input() childs: any;
  // ✅ Set date at property declaration level, not in ngOnInit
  date: any = moment().format('MM-YYYY');
  serviceData: any = [];

  dateRange: any;

  masterAccounts: any[];
  unselectedService: any[];
  comment: '';
  linkedAccounts: any;
  accounts: any;
  //   childs: any;
  selectedClientName: any = localStorage.getItem('selectedClientName');
  showS3DiscountFields: boolean;
  showRDSDiscountFields: boolean;
  showCloudFrontDiscountFields: boolean;
  showEC2DiscountFields: boolean = false;
  popupData: any[] = [];
  lek: any;
  service_Name: any;
  showPopup: boolean = false;
  processing: boolean = false;
  headers_pop: { id: string; name: string }[];
  selectedService: any;
  riApplied: any;
  odApplied: any;
  spotApplied: any;
  ebsapplied: any;
  othersapplied: any;
  isModalVisible: boolean;
  allCallsCompleted: boolean = false;
  initialChildsLoaded: boolean = false;

  constructor(
    private apiService: APIService,
    private notifier: NotifierService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    console.log('mrrdatasub', this.mrrDatasub);
    this.mrr = { ...this.mrr };
    this.accountId = localStorage.getItem('accountId');
    this.linkedAccounts = JSON.parse(
      localStorage.getItem('accountIdData') || '{}',
    );

    if (Array.isArray(this.linkedAccounts.list)) {
      this.accounts = this.linkedAccounts.list.map(
        (accountObj: any) => accountObj.account,
      );
    } else {
      console.error(
        'linkedAccounts does not have a valid list key or it is not an array.',
      );
    }

    setTimeout(() => {
      $('#linkedAccounts').selectpicker('refresh');
    }, 100);

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) return;
      if (d.key == 'accountId') {
        this.accountId = d.value;
        this.load();
      }
    });

    flatpickr('#dataRangePicker', {
      dateFormat: 'Y-m-d',
      mode: 'range',
      showMonths: 2,
      defaultDate: this.dateRange ? this.dateRange.split(' to ') : null,
      onChange: (selectedDates: any, dateStr: any, instance: any) => {
        if (!dateStr.includes('to')) return;
        this.dateRange = dateStr;
      },
    });

    if (this.action == 'update') {
      this.dateRange = this.mrr.startDate + ' to ' + this.mrr.endDate;
    }
  }

  load() {}

  isServiceDisabled(serviceName: string): boolean {
    console.log(this.mrrData);
    for (let service of this.mrrData) {
      if (service.serviceName === serviceName) {
        return true;
      }
    }
    return false;
  }

  selectAllchilds(event: any) {
    const isChecked = event.target.checked;
    if (isChecked) {
      // Select all accounts
      this.childs = this.linkedAccounts['list'].map(
        (account: any) => account.accountId,
      );
      this.serviceNames(this.childs);
    } else {
      // Deselect all accounts
      this.childs = [];
    }
    setTimeout(() => {
      $('#linkedAccounts').selectpicker('refresh');
    }, 10);
  }

  getFormData(): { isValid: boolean; data?: any; errors: string[] } {
    const errors: string[] = [];

    // Validate date range
    if (!this.dateRange || !this.dateRange.includes('to')) {
      errors.push('Please select a valid date range');
    }

    // ✅ Get service names and normalize to array regardless of action
    let serviceNamesRaw =
      this.action === 'update'
        ? this.mrr.serviceName // In update mode, use mrr.serviceName directly (string)
        : $('#serviceNameId').val(); // In add mode, selectpicker returns array

    // ✅ Always normalize to array
    const serviceNames: string[] = Array.isArray(serviceNamesRaw)
      ? serviceNamesRaw
      : serviceNamesRaw
        ? [serviceNamesRaw]
        : [];

    // Validate service selection
    if (!serviceNames || serviceNames.length === 0) {
      errors.push('Please select at least one service');
    }

    // Validate discount
    if (
      this.mrr.mrrDiscount === null ||
      this.mrr.mrrDiscount === undefined ||
      this.mrr.mrrDiscount === ''
    ) {
      errors.push('Please enter an MRR discount value');
    }

    // Validate child accounts (only required for 'add' action)
    if (this.action === 'add' && (!this.childs || this.childs.length === 0)) {
      errors.push('Please select at least one linked account');
    }

    if (errors.length > 0) {
      return { isValid: false, errors };
    }

    // Build date range
    const [start, end] = this.dateRange
      .split('to')
      .map((d: string) => d.trim());

    const data = {
      mrrList: serviceNames.map((serviceName: string) => ({
        serviceName,
        mrrDiscount: this.mrr.mrrDiscount,
        comment: this.mrr.comment,
        startDate: start,
        endDate: end,
        tableType: 'mrr',
      })),
      childs: this.childs,
      action: this.action,
      accountId: this.accountId,
      startDate: start,
      endDate: end,

      ...(this.action !== 'add' && { uuid: this.mrr.uuid ?? '' }),
    };

    return { isValid: true, data, errors: [] };
  }

  services: any;

  async updateEntry(child?: any): Promise<any> {
    // Initialize variables
    let data: any;
    let item;

    try {
      // Mark the item as loading
      // Prepare data based on action
      item = this.childs.find((s: any) => s.name === child.name); // Find `child` by name

      item.isLoading = true;
      item.isSuccess = false;
      item.isError = false;
      if (!this.dateRange) {
        this.notifier.alert(
          'Info',
          '',
          'Please select a date range',
          'info',
          500,
        );
        return;
      }

      const [start, end] = this.dateRange
        .split('to')
        .map((date: any) => date.trim());
      let serviceNames = $('#serviceNameId').val();

      for (let i = 0; i < serviceNames.length; i++) {
        this.selectedServiceNames.push({
          serviceName: serviceNames[i],
          mrrDiscount: this.mrr.mrrDiscount,
          comment: this.mrr.comment,
          startDate: start,
          endDate: end,
          tableType: 'mrr',
        });
        this.notSelectedService();
        // Pass child as lid directly to prepareAddData
        data = this.prepareAddData(child, start, end);
      }

      // Log prepared data for debugging
      console.log('API Request Data:', data);

      // API call
      const header = { Authorization: localStorage.getItem('t') };
      const apiURL = `${APIService.API_DISCOUNTENPOINT}`;
      const result = await this.apiService.postDataPromis(apiURL, data, header);

      // Handle API response
      if (result.status == '1' || result.s == '1') {
        item.isSuccess = true;
        if (this.action !== 'add') {
          this.notifier.alert('Success', '', result.msg, 'success', 5000);
          this.close(true);
        }
      } else {
        item.isError = true;
        if (this.action !== 'add') {
          this.close(true);
          this.notifier.alert('Error', '', result.msg, 'error', 5000);
        }
      }
    } catch (error) {
      if (this.action == 'add') {
        item.isError = true;
      }
    } finally {
      if (this.action == 'add') {
        // Ensure loading state is cleared
        item.isLoading = false;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['childs']) {
      if (this.childs && this.childs.length > 0) {
        this.serviceNames(this.childs);
      } else {
        // ✅ Accounts deselected — clear the dropdown
        this.serviceNamelist = [];
        this.cdr.detectChanges();
        setTimeout(() => {
          $('#serviceNameId').selectpicker('destroy');
          $('#serviceNameId').selectpicker();
          $('#serviceNameId').selectpicker('refresh');
        }, 0);
      }
    }
  }

  async processItemsSequentially(): Promise<void> {
    if (this.action == 'add') {
      this.isModalVisible = true;

      // Assuming `this.childs` is already populated via ngModel
      this.childs = this.childs.map((child: any) => ({
        name: child, // The child name (string)
        isLoading: true, // Initialize isLoading as true
        isSuccess: false, // Initialize isSuccess as false
        isError: false, // Initialize isError as false
      }));

      console.log('this.childs', this.childs);

      for (const child of this.childs) {
        try {
          // Call updateEntry for each child in the array
          await this.updateEntry(child);
        } catch (error) {
          console.error('Error processing child:', child, error);
        }
      }
      this.allCallsCompleted = true;
    } else {
      this.prepareUpdateData();
    }
  }

  prepareAddData(child: any, start: string, end: string): any {
    return {
      lid: child.name, // Add childs directly
      mrrList: this.selectedServiceNames,
      action: 'add',
      tableType: 'mrr',
    };
  }
  showOtpModal: boolean = false;
  enteredOtp: string = '';
  otpError: string = '';

  generatedOtp: string = '123456'; // for demo (normally from backend)

  async openOtpPopup() {
    this.otpError = '';
    this.showOtpModal = true;

    let data;
    this.notifier.loading(true);

    data = {
      email: localStorage.getItem('eId'),
    };
    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `${APIService.API_DISCOUNTENPOINT}/request-otp`;
    let result = await this.apiService.postDataPromis(apiURL, data, header);
    if (result.status == '1') {
      this.notifier.alert(
        'Info',
        '',
        'OTP has been sent to your email address',
        'info',
        5000,
      );
    } else {
      this.notifier.alert('Info', '', result.error, 'info', 5000);
      this.showOtpModal = false;
    }
    this.notifier.loading(false);
  }

  closeOtp() {
    this.showOtpModal = false;
  }

  async verifyOtp() {
    if (this.enteredOtp === this.generatedOtp) {
      this.showOtpModal = false;
      this.processItemsSequentially(); // ✅ Call only after success
    } else {
      this.otpError = 'Invalid OTP. Please try again.';
    }
    let data;
    this.notifier.loading(true);

    data = {
      email: localStorage.getItem('eId'),
      otp: this.enteredOtp,
    };
    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `${APIService.API_DISCOUNTENPOINT}/verify-otp`;
    let result = await this.apiService.postDataPromis(apiURL, data, header);
    if (result.status == '1') {
      this.notifier.alert('Info', '', result.response, 'info', 5000);
      this.showOtpModal = false;
      this.processItemsSequentially();
    } else {
      this.notifier.alert('Info', '', result.error, 'info', 5000);
    }
    this.notifier.loading(false);
  }

  async prepareUpdateData() {
    const start = this.mrr.startDate;
    const end = this.mrr.endDate;
    const serviceName = this.mrr.serviceName?.trim();
    let data;

    data = {
      lid: this.accountId,
      action: 'update',
      serviceName: this.mrr.serviceName,
      mrrDiscount: this.mrr.mrrDiscount,
      startDate: this.mrr.startDate,
      endDate: this.mrr.endDate,
      comment: this.mrr.comment,
      tableType: 'mrr',
    };

    const header = { Authorization: localStorage.getItem('t') };
    const apiURL = `${APIService.API_DISCOUNTENPOINT}`;
    const result = await this.apiService.postDataPromis(apiURL, data, header);

    // Handle API response
    if (result.status === '1' || result.s === '1') {
      this.notifier.alert('Success', '', result.msg, 'success', 5000);
      this.close(true);
    } else {
      this.notifier.alert('Error', '', result.msg, 'error', 5000);
      this.close(true);
    }
  }

  closeModal(): void {
    // Hide the modal when the close button is clicked
    this.isModalVisible = false;
    this.close(true);
  }

  resetPercentage(section: { isMrr: boolean; perc: number }): void {
    console.log('section', section);
    if (!section.isMrr) {
      section.perc = 0;
    }
  }

  onMrrDatasubUpdate(updatedData: any) {
    this.mrrDatasub = updatedData;
    console.log('Updated mrrDatasub:', this.mrrDatasub);
  }

  onDataChange(addData: any) {
    console.log(addData);
  }

  async setHeadersBasedOnService(serviceName: string) {
    // Define header configurations based on the service name
    if (serviceName === 'Amazon Elastic Compute Cloud') {
      this.headers_pop = [
        { id: 'instanceId', name: 'Instance ID' },

        { id: 'instanceName', name: 'Instance Name' },

        { id: 'instanceType', name: 'Instance Type' },
        { id: 'os', name: 'OS' },
        { id: 'region', name: 'Region' },
      ];
    } else if (serviceName === 'Amazon Relational Database Service') {
      this.headers_pop = [
        // { id: 'key', name: 'Key' },
        { id: 'region', name: 'Region' },
        { id: 'usageType', name: 'Usage Type' },
        { id: 'azType', name: 'Availability Zone Type' },
        { id: 'dbEngine', name: 'DB Engine' },
      ];
    } else if (serviceName === 'Amazon Simple Storage Service') {
      this.headers_pop = [
        // { id: 'key', name: 'Key' },
        { id: 'region', name: 'Region' },
        { id: 'usageType', name: 'Usage Type' },
      ];
    } else if (serviceName === 'Amazon CloudFront') {
      this.headers_pop = [
        // { id: 'key', name: 'Key' },
        { id: 'region', name: 'Region' },
        { id: 'usageType', name: 'Usage Type' },
      ];
    } else {
      // Default headers if the service name does not match
      this.headers_pop = [
        { id: 'serviceName', name: 'Service Name' },
        { id: 'mrrDiscount', name: 'MRR Discount' },
        { id: 'comment', name: 'Comment' },
      ];
    }
  }

  latestSelectedAccount: string | null = null;
  previousSelection: string[] = [];

  onAccountChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const selectedOptions = Array.from(selectElement.selectedOptions).map(
      (option) => option.value,
    );

    // Check if any new account is selected
    const newSelections = selectedOptions.filter(
      (option) => !this.previousSelection.includes(option),
    );

    // If there is a new selection, update the latestSelectedAccount
    if (newSelections.length > 0) {
      // Get the last selected account ID
      const latestAccountId = newSelections[newSelections.length - 1];

      // If using split, just in case unwanted characters are present
      const splitAccountId = latestAccountId
        .split(':')
        .pop()
        ?.trim()
        .replace(/'/g, ''); // Split and trim

      // Store only the account ID
      this.latestSelectedAccount = splitAccountId || null;
    }
    this.serviceNames(this.childs);
    // Update the previous selection list
    this.previousSelection = selectedOptions;
  }

  async openPopup(serviceName: any) {
    this.notifier.loading(true);
    await this.setHeadersBasedOnService(serviceName);
    console.log('headers_pop', this.headers_pop);
    const serviceMapping: { [key: string]: string } = {
      'Amazon Simple Storage Service': 's3',
      'Amazon Relational Database Service': 'rds',
      'Amazon Elastic Compute Cloud': 'ec2',
      'Amazon CloudFront': 'cfrc',
    };

    // Set the selected service's abbreviated name
    this.selectedService = serviceMapping[serviceName] || serviceName;
    console.log('selected service in popup', this.selectedService);
    this.selectedClientName = serviceName;
    this.notifier.loading(true);
    // this.popupData = [];
    this.service_Name = serviceName;
    if (this.lek == undefined) {
      this.notifier.loading(true);

      this.fetchDetails(serviceName);
      this.notifier.loading(false);
    }

    console.log(
      'serviceData[selectedService]',
      this.serviceData[this.selectedService],
    );
    this.showPopup = true;

    this.notifier.loading(false);
  }

  closePopup() {
    this.notifier.loading(true);
    this.service_Name = undefined;
    this.showPopup = false;
    this.popupData = [];
    this.notifier.loading(false);
    this.lek = undefined;
  }

  async fetchDetails(serviceName: any) {
    this.notifier.loading(true);

    const serviceMapping: { [key: string]: string } = {
      'Amazon Simple Storage Service': 's3',
      'Amazon Relational Database Service': 'rds',
      'Amazon CloudFront': 'cfrc',
      'Amazon Elastic Compute Cloud': 'ec2',
    };

    const abbreviatedServiceName = serviceMapping[serviceName] || serviceName;

    let data;
    if (this.lek === null || this.lek === undefined || this.lek === '') {
      this.serviceData[abbreviatedServiceName] = [];
      data = {
        month: this.date,
        childs: [this.accountId],
        mid: this.mid,
        a: abbreviatedServiceName,
        tableType: 'mrr',
      };
    } else {
      data = {
        month: this.date,
        childs: [this.accountId],
        mid: this.mid,
        a: abbreviatedServiceName,
        lek: this.lek,
        tableType: 'mrr',
      };
    }

    let header = { Authorization: localStorage.getItem('t') };
    let apiURL = `${environment.apiURL}admin/billing/mrr`;
    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.s == '1') {
      if (!result.lek) {
        this.serviceData[abbreviatedServiceName] = [
          ...(this.serviceData[abbreviatedServiceName] || []),
          ...result.riDetails,
        ];
        this.lek = result.lek;
      } else {
        this.lek = result.lek;
        this.serviceData[abbreviatedServiceName] = [
          ...(this.serviceData[abbreviatedServiceName] || []),
          ...result.riDetails,
        ];
      }
    } else {
      this.serviceData[abbreviatedServiceName] = [];
      this.lek = null;
    }

    this.popupData = this.serviceData[abbreviatedServiceName];
    this.notifier.loading(false);
  }

  async serviceNames(id: string) {
    if (!id || id.length === 0) return;
    this.notifier.loading(true);

    let data: any = {
      month: this.date,
      childs: id,
      mid: this.mid,
      entity: 'AWS',
      a: 'serviceList',
    };

    let header = { Authorization: localStorage.getItem('t') };
    let apiURL = `${environment.apiURL}/admin/billing/mrr`;
    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.serviceNamelist = result.services;

      // Force Angular to render *ngFor options first
      this.cdr.detectChanges();

      setTimeout(() => {
        // Destroy old selectpicker instance before reinitializing
        $('#serviceNameId').selectpicker('destroy');
        $('#serviceNameId').selectpicker();

        if (this.action.trim() == 'update') {
          $('#serviceNameId').val([this.mrr.serviceName]);
          $('#serviceNameId').selectpicker('refresh');
        } else if (this.action.trim() == 'add') {
          if (this.unsaved && this.unsaved.length > 0) {
            const selectElement = document.getElementById(
              'serviceNameId',
            ) as HTMLSelectElement;
            const optionsToDisable = this.unsaved.map(
              (item: { serviceName: string }) => item.serviceName,
            );
            for (let i = 0; i < selectElement.options.length; i++) {
              if (optionsToDisable.includes(selectElement.options[i].value)) {
                selectElement.options[i].disabled = true;
                selectElement.options[i].style.color = 'grey';
                selectElement.options[i].style.backgroundColor = '#f5f5f5';
              }
            }
          }
          // ✅ Do NOT patch any value for add mode — let user select fresh
          $('#serviceNameId').selectpicker('refresh');
        }
      }, 150); // ✅ 150ms gives *ngFor enough time after cdr.detectChanges()
    } else {
      this.serviceNamelist = [];
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }

    this.notifier.loading(false);
  }

  selectAllOpt() {
    this.notifier.loading(true);
    this.isAllSelect = !this.isAllSelect;

    if (
      this.serviceNamelist.includes('Amazon Elastic Compute Cloud') &&
      this.isAllSelect
    ) {
      console.log(
        'testing',
        this.serviceNamelist.includes('Amazon Elastic Compute Cloud'),
      );
      this.showEC2DiscountFields = true;
    } else {
      this.showEC2DiscountFields = false;
      console.log(
        'testing',
        this.serviceNamelist.includes('Amazon Elastic Compute Cloud'),
      );
    }

    setTimeout(async () => {
      $('#serviceNameId').selectpicker();
      if (this.isAllSelect) {
        $('#serviceNameId').val(this.serviceNamelist);
      } else {
        $('#serviceNameId').val([]);
      }
      $('#serviceNameId').selectpicker('refresh');
      this.notifier.loading(false);
    }, 100);
  }
  showDiscountFields: boolean = false;
  onServiceNameChange(event: any) {
    const selectedOptions = Array.from(event.target.options)
      .filter((option: any) => option.selected)
      .map((option: any) => option.value);
    // Check if 'Cloud Computing' is selected
    this.showS3DiscountFields = false;
    this.showRDSDiscountFields = false;
    this.showCloudFrontDiscountFields = false;
    this.showEC2DiscountFields = false;

    // Loop through selected options and set variables accordingly
    selectedOptions.forEach((option) => {
      switch (option) {
        case 'Amazon Simple Storage Service':
          this.showS3DiscountFields = true;
          this.fetchDetails('Amazon Simple Storage Service');
          break;
        case 'Amazon Relational Database Service':
          this.showRDSDiscountFields = true;
          this.fetchDetails('Amazon Relational Database Service');
          break;
        case 'Amazon CloudFront':
          this.showCloudFrontDiscountFields = true;
          this.fetchDetails('Amazon CloudFront');
          break;
        case 'Amazon Elastic Compute Cloud':
          this.showEC2DiscountFields = true;
          this.fetchDetails('Amazon Elastic Compute Cloud');
          break;
        default:
          break;
      }
    });
  }

  notSelectedService() {
    let selected: any = [];
    let newSelected = this.selectedServiceNames.map((item) => item.serviceName);
    if (this.unsaved.length == 0) {
      selected = this.selectedServiceNames.map(
        (service) => service.serviceName,
      );
    } else {
      selected = this.unsaved.map((service: any) => service.serviceName);
      selected = selected.concat(newSelected);
    }

    this.unselectedService = this.serviceNamelist.filter(
      (item: any) => !selected.includes(item),
    );
  }
  ngOnDestroy(): void {}

  trackByFn() {
    return true;
  }

  close(dataAction: any) {
    if (dataAction) {
      this.hideModel.emit(dataAction);
    } else {
      this.hideModel.emit(dataAction);
    }
  }
}
